import styled from 'styled-components';

export const Container = styled.div`
  > div {
    > p {
      width: 100%;
    }
  }
`;
